import React, { useState } from "react";
import { Typography } from "@mui/material";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import swal from "sweetalert";
import * as api from "../../../actions/api";
import PrescriberFormData from "./PrescriberFormData.js";
import Constants from "../../../services/Constants";
import { getARVFacilityList } from "../../../services/Common";
import encryptionService from "../../../services/encryptionService";

const EditPrescriber = (props) => {
  //get DispensingLanguage
  const DispensingLanguage = JSON.parse(
    localStorage.getItem("DispensingLanguage")
  );
  const lan = localStorage.getItem("LangCode");
  const menukey = "prescriber";
  const FacilityId = localStorage.getItem("FacilityId");

  const UserInfo = encryptionService.decryptUserInfo();
  const UserName = UserInfo == 0 ? "" : UserInfo[0].name;

 // const FacilityList = JSON.parse(localStorage.getItem("FacilityList"));
  const FacilityList = getARVFacilityList();

  const [generatedNumber, setgeneratedNumber] = useState("");

  const [formData, setFormData] = useState({
    lastName: "",
    firstName: "",
    initial: "",
    title: "",
    rxLevel: "",
    number: "",
    professional: "",
    staff: "",
    post: "",
    specialisation: "",
    demander: "",
    active: false,
    address1: "",
    contactNumber: "",
    contactNumberEmergency: "",
    city: "",
    emailWork: "",
    country: "",
    emailPersonal: "",
    UserId: "",
  });
  const [errorObject, setErrorObject] = useState({});
  const { id } = useParams();
  const queryClient = useQueryClient();

  const { data } = useQuery(
    ["prescriber", id],
    () =>
      api.getPrescriber(id).then((res) => {
        let TemNumber = res.data.number.split("-");
        setgeneratedNumber(TemNumber[2]);

        setFormData(res.data);
        return res.data;
      }),
    {
      enabled: Boolean(id),
    }
  );

  const { isLoading, mutate } = useMutation(api.updatePrescriber, {
    onSuccess: (data) => {
      if (data.status == 200) {
        if (FacilityId == data.FacilityId) {
          api
            .getFacilityListNotEqual99ANDSuppliers(
              "PrescriberList",
              data.FacilityId
            )
            .then((response) => {
              localStorage.setItem(
                "PrescriberList",
                JSON.stringify(response.datalist.PrescriberList)
              );
            });
        }

        queryClient.getQueriesData("prescriber");
        props.history.push("/prescriber");

        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      } else {
        props.openNoticeModal({
          isOpen: true,
          msg: data.message,
          msgtype: data.success,
        });
      }
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    let data = { ...formData };
    data[name] = value;

    if (name == "demander") {
      for (let i = 0; i < FacilityList.length; i++) {
        if (value == FacilityList[i].id) {
          data["number"] =
            "P-" + FacilityList[i].FacilityCode + "-" + generatedNumber;
          setFormData(data);
        }
      }
    } else setFormData(data);

    setErrorObject({ ...errorObject, [name]: null });
  };

  const handleCheck = (e) => {
    const { name, checked } = e.target;
    setFormData({ ...formData, [name]: checked });
  };

  const handleReset = () => {
    setFormData({
      lastName: "",
      firstName: "",
      initial: "",
      title: "",
      rxLevel: "",
      number: "",
      professional: "",
      staff: "",
      post: "",
      specialisation: "",
      demander: "",
      active: false,
      address1: "",
      contactNumber: "",
      contactNumberEmergency: "",
      city: "",
      emailWork: "",
      country: "",
      emailPersonal: "",
      UserId: "",
    });
  };

  const validateForm = (formData) => {
    let validateFields = ["lastName", "firstName", "rxLevel", "number"];
    let errorData = {};
    let isValid = true;
    validateFields.map((field) => {
      if (!formData[field]) {
        errorData[field] =
          DispensingLanguage[lan][menukey]["field is Required !"];
        isValid = false;
      }
    });
    setErrorObject(errorData);
    return isValid;
  };

  const handleUpdate = async (e) => {
    if (validateForm(formData)) {
      let fDtat = {
        ...formData,
        menukey: menukey,
        lan: lan,
        UserName: UserName,
      };
      mutate(fDtat);
    }
  };

    //====== Start Choosen Dropdown===========
    const handleChangeChoosenProps = (name, value) => {
      let data = { ...formData };
      data[name] = value;   
      setFormData(data); 
      setErrorObject({ ...errorObject, [name]: "" });
        
    }
    //====== End Choosen Dropdown===========
    
  return (
    <>
      <PrescriberFormData
        errorObject={errorObject}
        addProductForm={false}
        formData={formData}
        handleChange={handleChange}
        handleCheck={handleCheck}
        handleReset={handleReset}
        handleUpdate={handleUpdate}
        handleChangeChoosenProps={handleChangeChoosenProps}
        {...props}
      />
    </>
  );
};

export default EditPrescriber;
